import React, { useEffect, useState } from 'react';
// import { getAllParams } from '../../common/utils/qs';

function SAMLIframe() {
  const [ destinationUrl, setDestinationUrl ] = useState();
  const [ relayState, setRelayState ] = useState();
  const [ samlResponse, setSamlResponse ] = useState();

  useEffect(() => {
    window.addEventListener('message', (event) => {
      if (event.origin !== window.location.origin) {
        return;
      }
      const {
        data: {
          destination_url: destinationURL,
          RelayState,
          SAMLResponse,
        },
      } = event;

      if (destinationURL) setDestinationUrl(destinationURL);
      if (RelayState) setRelayState(RelayState);
      if (SAMLResponse) setSamlResponse(SAMLResponse);
    });
  }, []);

  useEffect(() => {
    if (destinationUrl && relayState && samlResponse) {
      document.forms.auto_submit.submit();
    }
  }, [destinationUrl, relayState, samlResponse]);

  return (
    <div>
      destination url: <br />
      {destinationUrl}
      <br />&nbsp;<br />
      relay state: <br />
      {relayState}
      <br />&nbsp;<br />
      saml response: <br />
      {samlResponse}
      <form action={destinationUrl} name="auto_submit">
        <input type="hidden" name="RelayState" value={relayState} />
        <input type="hidden" name="SAMLResponse" value={samlResponse} />
        <input type="submit" value="submit" />
      </form>
    </div>
  );
}

export default SAMLIframe;
